import React from "react";
import { PolarArea, Doughnut } from "react-chartjs-2";
import annotationPlugin from 'chartjs-plugin-annotation';
import { Chart as ChartJS, registerables } from 'chart.js';
import randomColor from "randomcolor";
ChartJS.register(...registerables);
ChartJS.register(annotationPlugin);


const DonutChart = ({ categories, selectedCat, topicID, handleChangeSelectedCategory, showAnnotation, width }) => {

  console.debug("categories", categories)

  let data = {
    // labels: Array.from({ length: 6 }).map((_, index) => `${index}`),
    labels: categories?.map((_, index) => `${index}`),
    datasets: [
      {
        label: "",
        // data: Array.from({length: 6}).map(() => 1),
        // backgroundColor: Array.from({length: 6}).map(_ => randomColor({luminosity:'bright'})),
        // backgroundColor: categories.map(_ => randomColor({luminosity:'bright'})),
        data: categories?.map(cat => 1),
        backgroundColor: categories?.map(cat => cat?.color),
        // hoverOffset: 20,
        // borderWidth: 10, 
        borderColor: 'transparent',
      },
    ],
  };


  const mapRange = (value) => {
    let fromLow = 0
    let fromHigh = 100
    let toLow = width === '50px' ? 10 : 100
    let toHigh = width === '50px' ? 20 : 150
    // Linear mapping function
    return (value - fromLow) * (toHigh - toLow) / (fromHigh - fromLow) + toLow;
  }

  const thickness = {
    id: "thickness",
    beforeDraw: function (chart, options) {
      let r = 1
      // let thickness = [115, 90, 90, 100, 90, 105];
      let thicknessArr = categories?.map((cat) => {
        return mapRange(cat.accuracyIndex)
      })
      // console.debug("thicknessArr", width, thicknessArr)
      thicknessArr?.forEach((item, index) => {
        if (chart.getDatasetMeta(0)?.data[index]) {
          chart.getDatasetMeta(0).data[index].innerRadius = item;
        }
        if (chart.getDatasetMeta(0).data[index]) {
          chart.getDatasetMeta(0).data[index].outerRadius = r;
        }

      });
    }
  };

  return (
    <div style={{
      position: "relative",
      width: width,
    }}>
      <Doughnut
        data={data}
        plugins={[thickness]}
        options={{
          onClick: (event, chartElement, chart) => {
            if (chartElement.length && categories?.length) {
              let catIndex = chartElement[0].index;
              let cat = categories[catIndex]
              if (handleChangeSelectedCategory) {
                handleChangeSelectedCategory(cat)
              }
              
            }
            
          },
          // cutout:"50%",
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            annotation: {
              clip: false,
              common: {
                drawTime: 'afterDatasetsDraw',
              },
              annotations: {
                border1: {
                  // display: showAnnotation,
                  type: 'point',
                  drawTime: 'afterDatasetsDraw',
                  xValue: 0,
                  yValue: 0,
                  xAdjust: 0,
                  yAdjust: 0,
                  radius:  width === '50px' ? 20 : 150,
                  borderWidth:  width === '50px' ? 1 : 2,
                  borderColor:"#d9d9d9",
                  backgroundColor: 'transparent',
                  z: 99,
                },
                smallPoint: {
                  display: showAnnotation,
                  type: 'point',
                  xValue: 0,
                  xAdjust: 0,
                  yValue: 0,
                  yAdjust: -70,
                  radius: 8,
                  backgroundColor: selectedCat?.color,
                  borderWidth: 0,
                },
                catName: {
                  display: showAnnotation,
                  type: 'label',
                  xValue: 0,
                  xAdjust: 0,
                  yAdjust: -35,
                  content: selectedCat?.label ? selectedCat?.label.match(/\b\w+(\s\w+)?\b/g) : selectedCat?.name.match(/\b\w+(\s\w+)?\b/g),
                  font: {
                    size: 16,
                    weight: 'bold',
                  },
                  color: '#000',
                },
                label2: {
                  display: showAnnotation,
                  type: 'label',
                  xValue: 0,
                  xAdjust: -55,
                  yValue: 0,
                  yAdjust: 25,
                  content: ['Accuracy', selectedCat?.accuracyIndex ? `${selectedCat?.accuracyIndex.toFixed(1)}%` : ''],
                  font: [{ size: 14 }, { size: 18, weight: 'bold' }],
                  color: ['#000000', '#222']
                },
                label3: {
                  display: showAnnotation,
                  type: 'label',
                  xValue: 0,
                  xAdjust: 55,
                  yValue: 0,
                  yAdjust: 25,
                  content: ['Time', selectedCat?.timeInSec ? `${selectedCat?.timeInSec}s` : ''],
                  font: [{ size: 14 }, { size: 18, weight: 'bold' }],
                  color: ['#000000', '#222'],
                },
                // point2: {
                //   display: showAnnotation,
                //   type: 'point',
                //   drawTime: 'afterDatasetsDraw',
                //   xAdjust: 0,
                //   yAdjust: 0,
                //   radius: 80,
                //   borderWidth: 0,
                //   backgroundColor: "white",
                //   z: -1
                // },
                point3: {
                  // display: showAnnotation,
                  type: 'point',
                  drawTime: 'afterDatasetsDraw',
                  xValue: 0,
                  yValue: 0,
                  xAdjust: 0,
                  yAdjust: 0,
                  radius: width === '50px' ? 8 : 100,
                  borderWidth: 0,
                  backgroundColor: selectedCat?.backgroundColor && showAnnotation ? selectedCat?.backgroundColor : 'white',
                  z: -1,
                },
              }
            },

            legend: {
              display: false,
            },
            tooltip: {
              enabled: showAnnotation,
              displayColors: true,
              callbacks: {
                title: function (context) {
                  let index = context[0].dataIndex;
                  let catName = categories[index].label ? categories[index].label : categories[index].name;
                  return catName
                },
                // label: function (context) {
                //   let index = context.dataIndex;
                //   let value = categories[index].accuracyIndex.toFixed(1);
                //   return `Accuracy Index: ${value}`
                // },
                label: function (context) {
                      let index = context.dataIndex;
                      let accuracyIndex = categories[index].accuracyIndex.toFixed(1);
                      let timeInSec = categories[index].timeInSec;
                      return [` Accuracy Index: ${accuracyIndex}`, ` Time in Sec: ${timeInSec}`]
                  },
              },
            },
          },
          // scales: {
          //   r: {
          //     grid: {
          //       display: false
          //     }
          //   },
          // },
          
        }}
      />
    </div>
  );
};

export default DonutChart;
